import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RegisterService } from './register.service';

@Component({
  selector: 'app-register-boxed',
  templateUrl: './register-boxed.component.html',
  styles: []
})
export class RegisterBoxedComponent implements OnInit {
email="";
password="";

  constructor(private toatr:ToastrService,
              private spinner:NgxSpinnerService,
              private registerService:RegisterService,
              private router:Router) { }

  ngOnInit() {
  }


  register(){
    this.spinner.show();
    let sendData = {
      "firstName": "Jitendra",
      "lastName": "Singh",
      "emailId": this.email,
      "password": this.password,
      "phoneNumber": "+919876543210",
      "address": "Pune",
      "city": "Pune",
      "state": "Maharashtra",
      "pincode": "411057",
      "refBy": "NA",
      "ipAddress": "0.0.0.0",
      "userType": "Individual",
      "deviceToken": "",
      "source": "advertisement"
    }
    this.registerService.register(sendData).subscribe((result:any)=>{
        console.log('resgister response  ',result)
        if(result.statusCode  == 200){
          this.spinner.hide();
          this.toatr.success(result.message);
        }else{
          this.spinner.hide();
          this.toatr.error(result.message);
        }
    })


  }





  login(){
    this.router.navigateByUrl('pages/login-boxed')
  }
}
